import * as API from '../../requests'
import ActiveRecord from './active_record/base'
import {getGlobal} from '../helpers'
import _ from 'lodash'

class TradeRequest extends ActiveRecord {
	static tableName = 'tradeRequests'

	constructor(props) {
		super(props)
		this.type = this.getType()
		this.subType = this.getSubType()
		this.tradeDirection = this.getTradeDirection()
	}

	accordable = () => {
		return this.bieder_ids.length > 0
	}

	approve = async (userId, afterSucc = _.noop) => {
		const res = await this.update({published: true, ruilee_id: userId})
		if (res.ok) {
			afterSucc(userId)
			return res
		}
		return res
	}

	acceptRequest = async () => {
		return await API.addAssoc('trade_requests', {bieder_ids: [getGlobal('meId')], id: this.id})
	}

	rejectRequest = async () => {
		return await API.addAssoc('trade_requests', {afwijzer_ids: [getGlobal('meId')], id: this.id})
	}

	getReceivingUserIds = () => {
		return [...this.bieder_ids, ...this.afwijzer_ids, ...this.potential_ruiler_ids].uniq()
	}

	getType = () => {
		if (this.swap_shift_id) return 'swap'
		if (this.ruiler_id) return 'take_over'
		return 'open_shift'
	}

	getSubType = () => {
		if (this.type === 'take_over') {
			if (this.ruiler_id === getGlobal('meId')) {
				return 'outgoing_take_over'
			} else {
				return 'incoming_take_over'
			}
		}

		return this.type
	}

	getTradeDirection = () => {
		if (this.type === 'take_over') {
			if (this.ruiler_id === getGlobal('meId')) {
				return 'outgoing'
			} else {
				return 'incoming'
			}
		}

		if (this.type === 'swap') {
			if (this.ruiler_id === getGlobal('meId')) {
				return 'outgoing'
			} else {
				return 'incoming'
			}
		}

		if (this.type === 'open_shift') return 'incoming'
	}

	getStatus = () => {
		if (this.published) return 'approved'
		if (this.bieder_ids.length) return 'pending_approval'
		if (!this.bieder_ids.length) return 'pending_acceptance'
	}

	getPotentialTakeOverUserStatus = userId => {
		if (this.bieder_ids.includes(userId)) return 'accepted'
		if (this.afwijzer_ids.includes(userId)) return 'rejected'
		return 'pending'
	}
}

export default TradeRequest
